import { RouteObject } from "react-router";

import KioskBookingPage from "@components/Kiosk/BookingPage/BookingPage";
import KioskDeviceError from "@components/Kiosk/DeviceError/DeviceError";
import KioskInstall from "@components/Kiosk/Install/KioskInstall";
import KioskLogin from "@components/Kiosk/Login/Login";
import ScreenSaver from "@components/Kiosk/ScreenSaver/ScreenSaver";
import { kioskRouteEnum } from "@enums/route.enum";
import KioskLayout from "@layouts/KioskLayout";

import KioskRedirectGuard from "./guards/KioskRedirectGuard";
import RequireAuth from "./RouteAuth";

export const KioskRoutes: RouteObject[] = [
  {
    children: [
      {
        children: [
          { element: <KioskBookingPage />, path: kioskRouteEnum.Booking },
        ],
        element: <KioskRedirectGuard />,
      },
      { element: <ScreenSaver />, path: kioskRouteEnum.Landing },
      { element: <KioskLogin />, path: kioskRouteEnum.Login },
      { element: <KioskInstall />, path: kioskRouteEnum.Install },
      { element: <KioskDeviceError />, path: kioskRouteEnum.DeviceError },
      {
        children: [
          { element: <KioskBookingPage />, path: kioskRouteEnum.Booking },
        ],
        element: <RequireAuth HomeRoute={kioskRouteEnum.Login} />,
      },
      { element: <ScreenSaver />, path: "*" },
    ],
    element: <KioskLayout />,
  },
];
